import { useMutation } from '@tanstack/react-query';
import { apiClient, queryClient } from '@common/http/query-client';
import { BackendResponse } from '@common/http/backend-response/backend-response';
import { toast } from '@common/ui/toast/toast';
import { message } from '@common/i18n/message';
import { showHttpErrorToast } from '@common/utils/http/show-http-error-toast';
import { DatatableDataQueryKey } from '@common/datatable/requests/paginated-resources';

interface MdFormatResponse extends BackendResponse {
  message?: string;
}

interface Payload {
  id: number;
  market_rate_date: string;
  investor_code: string;
  sheet_names: string[];
  loan_program_types: any[];
}

export function useMdFormatAction(id: number, market_rate_date: string, investor_code: string, sheet_names: string[], loan_program_types: any[]) {
  return useMutation({
    mutationFn: (payload: Payload) => executeMdFormatAction(payload),
    onSuccess: (response: MdFormatResponse) => {
      toast(
        response.message
          ? message(response.message)
          : message(`You have executed check for ${investor_code}.`)
      );
      queryClient.invalidateQueries({ queryKey: DatatableDataQueryKey(`market-rates/${market_rate_date}`) });
    },
    onError: (err) => {
      if (err instanceof Error) {
        showHttpErrorToast(err);
      } else {
        toast.danger(message('An unexpected error occurred.'));
      }
    },
  });
}

function executeMdFormatAction({ id, investor_code, sheet_names, loan_program_types }: Payload): Promise<MdFormatResponse> {
  return apiClient.post(`market-rates/${id}/execute-md-format-action`, {
    investor_code,
    sheet_names,
    loan_program_types
  });
}